import { render, staticRenderFns } from "./DashboardScreening.vue?vue&type=template&id=9d1d0a96&scoped=true&"
import script from "./DashboardScreening.vue?vue&type=script&lang=js&"
export * from "./DashboardScreening.vue?vue&type=script&lang=js&"
import style0 from "./DashboardScreening.vue?vue&type=style&index=0&id=9d1d0a96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d1d0a96",
  null
  
)

export default component.exports